module.exports = __webpack_public_path__ + "static/media/Quant.e3275aac.png";